__turbopack_context__.v({
  "actions": "base-module__7G06uG__actions",
  "baseCalloutOrToast": "base-module__7G06uG__baseCalloutOrToast",
  "baseContainer": "base-module__7G06uG__baseContainer",
  "baseContent": "base-module__7G06uG__baseContent",
  "base__callout": "base-module__7G06uG__base__callout",
  "close": "base-module__7G06uG__close",
  "color__grey": "base-module__7G06uG__color__grey",
  "color__orange": "base-module__7G06uG__color__orange",
  "color__teal": "base-module__7G06uG__color__teal",
  "icon": "base-module__7G06uG__icon",
  "icon__grey": "base-module__7G06uG__icon__grey",
  "icon__orange": "base-module__7G06uG__icon__orange",
  "icon__teal": "base-module__7G06uG__icon__teal",
  "sideColor": "base-module__7G06uG__sideColor",
});
